import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  token: localStorage.getItem(process.env.REACT_APP_TOKEN) || null,
  userId: localStorage.getItem(process.env.REACT_APP_USER_ID) || null,
  userType: localStorage.getItem(process.env.REACT_APP_USER_ACCOUNT_TYPE) || null,
  isLoggedIn: !!localStorage.getItem(process.env.REACT_APP_TOKEN),
  userName: localStorage.getItem(process.env.REACT_APP_USER_NAME) || null,
  tracking: false,
};

export const counterSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    login: (state, { payload }) => {
      localStorage.setItem(process.env.REACT_APP_TOKEN, payload.token);
      localStorage.setItem(process.env.REACT_APP_USER_ID, payload.userId);
      localStorage.setItem(process.env.REACT_APP_USER_NAME, payload.userName);
      localStorage.setItem(process.env.REACT_APP_USER_ACCOUNT_TYPE, payload.userType);
      state.token = payload.token;
      state.userId = payload.userId;
      state.userType = payload.userType;
      state.userName = payload.userName;
      state.isLoggedIn = true;
    },
    logout: (state) => {
      state.token = null;
      state.userType = null;
      state.userName = null;
      state.isLoggedIn = false;
      localStorage.removeItem(process.env.REACT_APP_USER_NAME);
      localStorage.removeItem(process.env.REACT_APP_USER_ID);
      localStorage.removeItem(process.env.REACT_APP_TOKEN);
      localStorage.removeItem(process.env.REACT_APP_USER_ACCOUNT_TYPE);
    },
  },
});

export const { login, logout } = counterSlice.actions;

export default counterSlice.reducer;
